<!-- 我的订单 -->
<template>
  <div class="user-order-container">
    <!--程序报错，暂时注释掉-->
    <div class="user-order-header"></div>
    <div class="user-order-main">
      <!-- 头部进度条 -->
      <div>
        头进度条
      </div>

      <div class="commodity-list">
        <div class="title">基本信息</div>
        <div class="commodity-content">
          <el-row class="base-info">
            <el-col :span="24">
              <div class="name">询价商品类型:</div>
              <div class="des">是是</div>
            </el-col>
          </el-row>
          <el-row class="base-info">
            <el-col :span="24">
              <div class="name">询价单名称:</div>
              <div class="des">是是</div>
            </el-col>
          </el-row>
          <el-row class="base-info">
            <el-col :span="12">
              <div class="name">报价截止日期:</div>
              <div class="des">是是</div>
            </el-col>
            <el-col :span="12">
              <div class="name">询价类型:</div>
              <div class="des">是是 查看详情列表弹窗</div>
            </el-col>
          </el-row>
          <el-row class="base-info">
            <el-col :span="12">
              <div class="name">联系人:</div>
              <div class="des">是是</div>
            </el-col>
            <el-col :span="12">
              <div class="name">联系电话:</div>
              <div class="des">是是</div>
            </el-col>
          </el-row>
          <el-row class="base-info">
            <el-col :span="12">
              <div class="name">期望到货日期:</div>
              <div class="des">是是</div>
            </el-col>
            <el-col :span="12">
              <div class="name">报价要求:</div>
              <div class="des">是是</div>
            </el-col>
          </el-row>
          <el-row class="base-info">
            <el-col :span="24">
              <div class="name">收货地址:</div>
              <div class="des">是是</div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="commodity-list">
        <div class="title">商品清单</div>
        <div class="commodity-content table-list">
          <div class="tab-content">
            <div
              v-for="(item, index) of tabArr"
              class="tab-btn"
              :class="{ active: currentIndex === index }"
              @click="handleTab(index)"
            >
              <span style="padding-right: 8px;">{{ item }}</span>
            </div>
          </div>
          <!-- table内容 搜索 列表 页脚 -->
          <button @click="quotationDetail">查看详情</button>
          <div class="table-content" v-if="currentIndex === 0">
            <!-- 搜索 -->
            <div class="search-content">
              <el-form :model="listQuery" class="search-form" size="small">
                <el-form-item label="询价单编号：">
                  <el-input
                    v-model.trim="listQuery.orderNo"
                    placeholder="请输入询价单编号"
                  ></el-input>
                  <el-button size="small" type="primary" style="float: right">查 询</el-button>
                </el-form-item>
              </el-form>
            </div>
            <!-- table列表 -->
            <el-table
              :data="tableData"
              border
              size="small"
              style="width: 100%"
              :header-cell-style="{ background: '#F5F5F5' }"
            >
              <el-table-column
                prop="date"
                label="询价单号"
                width="180"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="name"
                label="询价单名称"
                width="180"
                align="center"
              ></el-table-column>
              <el-table-column prop="address" label="询价类型" align="center"></el-table-column>
              <el-table-column
                prop="date"
                label="询价发布时间"
                width="180"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="date"
                label="询价发布时间"
                width="180"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="date"
                label="询价单状态"
                width="180"
                align="center"
              ></el-table-column>
              <el-table-column label="操作" width="180" align="center">
                <template>
                  <el-button>
                    查看详情
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <!-- 页 -->
            <div class="pagination">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[10, 20, 30]"
                layout="total, sizes, prev, pager, next, jumper"
                :current-page="listQuery.pageNum"
                :total="total"
                :small="true"
                :page-size.sync="listQuery.pageSize"
              ></el-pagination>
            </div>
          </div>
          <div class="table-content" v-if="currentIndex === 1">
            <div class="search-content">
              <el-form :model="listQuery" class="search-form-other" size="small">
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="询价商品筛选：">
                      <el-input v-model="listQuery.user" placeholder="询价商品筛选"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="供应商名称筛选：">
                      <el-input v-model="listQuery.user" placeholder="供应商名称筛选"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <div class="other-search-btn">
                      <el-button size="small" type="primary">重 置</el-button>
                      <el-button size="small" type="primary">查 询</el-button>
                    </div>
                  </el-col>
                </el-row>
              </el-form>
            </div>
            <div class="table-item">
              <div class="table-top">
                <div>
                  <span>询价商品：测试商品名称测试商品名称1</span>
                  <span>品牌：测试品牌</span>
                  <span>规格参数：测试规格参数1测试规格参...</span>
                </div>
                <div>
                  <span>需求数量：50000 个 (已选0个)</span>
                </div>
              </div>
              <el-table
                :data="tableData"
                border
                size="small"
                style="width: 100%"
                :header-cell-style="{ background: '#F5F5F5' }"
              >
                <el-table-column
                  prop="date"
                  label="商品名称"
                  width="180"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="name"
                  label="报价单总价(元)"
                  width="180"
                  align="center"
                ></el-table-column>
                <el-table-column prop="address" label="税率(%)" align="center"></el-table-column>
                <el-table-column
                  prop="date"
                  label="运费(元)"
                  width="180"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="date"
                  label="报价有效期"
                  width="180"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="date"
                  label="报价有限期至"
                  width="180"
                  align="center"
                ></el-table-column>

                <el-table-column prop="date" label="附加信息" width="180" align="center">
                  <template>
                    <el-button>下载附件</el-button>
                    <el-button>查看备注</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="table-item">
              <div class="table-top">
                <div>
                  <span>询价商品：测试商品名称测试商品名称1</span>
                  <span>品牌：测试品牌</span>
                  <span>规格参数：测试规格参数1测试规格参...</span>
                </div>
                <div>
                  <span>需求数量：50000 个 (已选0个)</span>
                </div>
              </div>
              <el-table
                :data="tableData"
                border
                size="small"
                style="width: 100%"
                :header-cell-style="{ background: '#F5F5F5' }"
              >
                <el-table-column
                  prop="date"
                  label="商品名称"
                  width="180"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="name"
                  label="报价单总价(元)"
                  width="180"
                  align="center"
                ></el-table-column>
                <el-table-column prop="address" label="税率(%)" align="center"></el-table-column>
                <el-table-column
                  prop="date"
                  label="运费(元)"
                  width="180"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="date"
                  label="报价有效期"
                  width="180"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="date"
                  label="报价有限期至"
                  width="180"
                  align="center"
                ></el-table-column>

                <el-table-column prop="date" label="附加信息" width="180" align="center">
                  <template>
                    <el-button>下载附件</el-button>
                    <el-button>查看备注</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="table-item">
              <div class="table-top">
                <div>
                  <span>询价商品：测试商品名称测试商品名称1</span>
                  <span>品牌：测试品牌</span>
                  <span>规格参数：测试规格参数1测试规格参...</span>
                </div>
                <div>
                  <span>需求数量：50000 个 (已选0个)</span>
                </div>
              </div>
              <el-table
                :data="tableData"
                border
                size="small"
                style="width: 100%"
                :header-cell-style="{ background: '#F5F5F5' }"
              >
                <el-table-column
                  prop="date"
                  label="商品名称"
                  width="180"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="name"
                  label="报价单总价(元)"
                  width="180"
                  align="center"
                ></el-table-column>
                <el-table-column prop="address" label="税率(%)" align="center"></el-table-column>
                <el-table-column
                  prop="date"
                  label="运费(元)"
                  width="180"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="date"
                  label="报价有效期"
                  width="180"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="date"
                  label="报价有限期至"
                  width="180"
                  align="center"
                ></el-table-column>

                <el-table-column prop="date" label="附加信息" width="180" align="center">
                  <template>
                    <el-button>下载附件</el-button>
                    <el-button>查看备注</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="pagination">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[10, 20, 30]"
                layout="total, sizes, prev, pager, next, jumper"
                :current-page="listQuery.pageNum"
                :total="total"
                :small="true"
                :page-size.sync="listQuery.pageSize"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>

      <div class="bottom-btn">
        <el-button size="small">关闭页面</el-button>
        <div style="float: right;">
          <el-button size="small">作废此次询价</el-button>
          <el-button size="small">根据已选商品生成订单</el-button>
          <el-button size="small">询价完成</el-button>
        </div>
        <div></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: [],
      tabArr: ['报价单', '报价统览'],
      currentIndex: 0,
      listQuery: {},
    };
  },
  methods: {
    handleTab(index) {
      this.currentIndex = index;
    },
    quotationDetail() {
      this.$router.push({
        path: `/enquiry/enquiryManage/quotationDetail`,
        qeury: {},
      });
    },
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.user-order-container {
  width: 100%;
  padding: 20px;

  .user-order-main {
    width: 1200px;
    margin: 30px auto;
    .tab-content {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #d9d9d9;
      .tab-btn {
        position: relative;
        bottom: -1px;
        width: 110px;
        height: 40px;
        line-height: 40px !important;
        text-align: center;
        display: inline-block;
        line-height: 1;
        cursor: pointer;
        color: #000;
        -webkit-appearance: none;
        text-align: center;
        box-sizing: border-box;
        outline: 0;
        margin: 0;
        transition: 0.1s;
        font-weight: 500;
        font-size: 14px;
        border: 1px solid #d9d9d9;
        border-bottom: none;
        &:last-child {
          border-right: 1px solid #d9d9d9;
        }
        &.active {
          background: #2587ff;
          color: #fff;
          border: none;
        }
      }
    }
    .search-content {
      overflow: hidden;
      width: 100%;
      .search-form {
        .el-input {
          width: 200px;
        }
      }
      .search-btn {
        float: right;
      }
      .el-form-item {
        margin: 20px 0;
      }
    }

    .commodity-list {
      border: 1px solid #f5f5f5;
      &:last-child {
        margin-top: 10px;
      }
      .title {
        height: 40px;
        line-height: 40px;
        background: #f5f5f5;
        padding-left: 20px;
      }
      .commodity-content {
        padding: 0 20px 20px 20px;
        .base-info {
          .el-col {
            display: flex;
            font-size: 14px;
            line-height: 1;
            margin-top: 20px;
            .name {
              flex: 0 0 200px;
              text-align: right;
              margin-right: 10px;
            }
            .des {
              flex: 1;
            }
          }
        }

        .search-form-other {
          overflow: hidden;
          .el-input {
            width: 200px;
          }
          .el-form-item {
            width: 400px;
          }
          .search-btn {
            float: right;
          }
          .el-col {
            margin: 0;
          }
          .other-search-btn {
            text-align: right;
            margin: 20px 0;
          }
        }
        .table-content {
          .table-item {
            margin-top: 30px;
            &:nth-of-type(2) {
              margin-top: 0;
            }
            .table-top {
              display: flex;
              justify-content: space-between;
              align-items: center;
              height: 40px;
              background: #f4f7ff;
              padding-left: 20px;
              margin-bottom: 10px;
            }
          }
          .pagination {
            margin-top: 20px;
          }
        }
      }
      .table-list {
        padding-top: 20px;
      }
    }
    .bottom-btn {
      margin-top: 20px;
    }
  }
}
</style>
